import { Anchor, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

/**
 * Authorized practitioners may open the shared Group Therapy note from a
 * patient-specific fan-out copy (PRD §11). Patients never see this link.
 */
export function GroupSharedNoteLink(props: {
  sharedNoteReference?: string;
  appointmentId?: string;
}): JSX.Element | null {
  const { sharedNoteReference, appointmentId } = props;
  if (!sharedNoteReference && !appointmentId) return null;

  if (appointmentId) {
    return (
      <Text size="sm">
        Group Therapy note —{' '}
        <Anchor component={Link} to={`/dashboard/appointments/${appointmentId}`}>
          Open shared session note
        </Anchor>
      </Text>
    );
  }

  return (
    <Text size="sm" c="dimmed">
      Linked shared Group note: {sharedNoteReference}
    </Text>
  );
}
